<template>
  <div class="member-level" style="min-width: 1086px">
    <div class="section-right-content-box">
      <div class="top-panel">
        <div class="global-title">
          营销洞察
          <!-- <span class="top-panel_span">M:购买金额</span>  -->
        </div>
      </div>
      <div class="contentAll">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="RF分析" name="first">
            <span class="top-panel_span">R:最近下单时间</span>
            <span class="top-panel_span">F:总购买次数</span>
            <!-- rfm模型列表 -->
            <div class="rfm">
              <div>
                <div class="border qqq overstriking">RF模型</div>
                <div
                  v-for="(item, index) in tabelDataListsss"
                  :key="index"
                  class="border sss"
                >
                  <div class="overstriking">{{ item.name }}</div>
                  <div>{{ item.label }}</div>
                </div>
                <div class="border qqq red gray">列总计</div>
              </div>
              <div>
                <div class="buy">
                  <div class="border qqq overstriking">F=1(购买1次)</div>
                  <div class="border qqq overstriking gray">F=2(购买2次)</div>
                  <div class="border qqq overstriking">F=3(购买3次)</div>
                  <div class="border qqq overstriking gray">F=4(购买4次)</div>
                  <div class="border qqq overstriking">F≥5(购买5次)</div>
                </div>
                <div
                  v-for="(item, index) in tabelData"
                  :key="index"
                  class="nums"
                >
                  <div
                    v-for="(_item, _index) in item"
                    :key="_index"
                    class="border count"
                  >
                    <div
                      class="wrap"
                      :class="
                        _item.buyerNum == 0
                          ? 'bgone'
                          : '' || (0 < _item.buyerNum && _item.buyerNum <= 1)
                          ? 'bgtwo'
                          : '' || (1 < _item.buyerNum && _item.buyerNum <= 2)
                          ? 'bgthree'
                          : '' || _item.buyerNum > 2
                          ? 'bgfour'
                          : '' || _item.avgPrice == 0
                          ? 'bgone'
                          : '' || (0 < _item.avgPrice && _item.avgPrice <= 1)
                          ? 'bgtwo'
                          : '' || (1 < _item.avgPrice && _item.avgPrice <= 2)
                          ? 'bgthree'
                          : '' || _item.avgPrice > 2
                          ? 'bgfour'
                          : '' || _item.amount == 0
                          ? 'bgone'
                          : '' || (0 < _item.amount && _item.amount <= 1)
                          ? 'bgtwo'
                          : '' || (1 < _item.amount && _item.amount <= 2)
                          ? 'bgthree'
                          : '' || _item.amount > 2
                          ? 'bgfour'
                          : ''
                      "
                    >
                      <div v-show="radio === 3">
                        <span> {{ _item.buyerNum }}人</span>
                        <div
                          v-if="
                            _item.customerPercent === 99.99 &&
                            _item.buyerNum != 0
                          "
                        >
                          {{ "大于99.99%" }}
                        </div>
                        <div
                          v-else-if="
                            _item.customerPercent === 0 && _item.buyerNum != 0
                          "
                        >
                          {{ "小于0.01%" }}
                        </div>
                        <div v-else>(占比{{ _item.customerPercent }}%)</div>
                      </div>
                      <!-- <div class="note display btn" style="display:none"> -->

                      <!-- <div v-show="radio === 6">
                        <span> {{ _item.avgPrice }}元</span>
                        <div>(占比{{ _item.avgPricePercent }}%)</div>
                      </div>

                      <div v-show="radio === 9">
                        <span> {{ _item.amount }}元</span>
                        <div>(占比{{ _item.accumulaPricePercent }}%)</div>
                      </div> -->

                      <div
                        class="note display btn aaa"
                        v-show="
                          _item.buyerNum != 0 &&
                          _item.avgPrice != 0 &&
                          _item.amount != 0"
                      >
                        <button
                        v-zoom='{from:pageName,name:"生成人群"}'
                          @click="SendTextMessage(item, _item, index, _index)">
                          生成人群
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="nums">
                  <!-- 列总计 -->
                  <div
                    v-for="(item, index) in listtwo"
                    :key="index"
                    class="twogary"
                  >
                    <div class="border qqq" v-if="item === 99.99">
                      {{ "大于99.99%" }}
                    </div>
                    <div class="border qqq" v-else>
                      <!-- <div v-show="radio === 3"> 人 {{ item }}%</div> -->
                      {{ item }}%
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="border qqq gray red">行合计</div>
                <div
                  class="border qqq sss"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <div v-if="item === 99.99">{{ "大于99.99%" }}</div>
                  <div v-else>{{ item }}%</div>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="客户流失分析" name="second">
            <div
              class="details"
              style="background: #fafafa; padding: 10px; width: 100%"
            >
              <img
                src="@/assets/images/new_icon_reminder.png"
                style="
                  display: inline-block;
                  width: 14px;
                      position: absolute;
                  height: 14px;
                  color: #ffffff;
                  margin: 2px 4px 0px 3px;
                "
              />
              <div>
              <div style="line-height:20px;margin-left: 20px;">
                距离上次购买后超过180天未购的客户算作流失客户（可修改流失天数定义）；一次购买流失客户指的是成交次数为一次，满足流失条件的客户，其他以此类推
              </div>
              </div>
            </div>
            <el-radio-group
              v-model="timeType"
              @change="changeTime"
              style="margin: 20px"
            >
              <el-radio :label="7">近7天</el-radio>
              <el-radio :label="30">近30天</el-radio>
            </el-radio-group>
            <el-button
              style="float: right; margin: 20px 60px 20px 20px"
              v-zoom='{from:pageName,name:"自定义参数"}'
              @click="dialogVisChange = true"
              >自定义参数</el-button
            >
            <div
              style="clear: left; height: 600px"
              ref="payRemindChart"
              class="chart"
              v-loading="loading"
            ></div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <el-dialog title="生成人群" :visible.sync="dialogFormVisRf" width="600px">
      <div
        class="details"
        style="
          background: #fafafa;
          padding: 10px;
          width: 90%;
          margin: 0 0 20px 25px;
        "
      >
        <img
          src="@/assets/images/new_icon_reminder.png"
          style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 0 4px 0px 3px;
          "
        />
        <p>生成的人群或保存在会员分群列表中</p>
      </div>
      <el-form :model="formRf">
        <el-form-item label="人群名称:" :label-width="formLabelWidth" required>
          <el-input
            v-model="formRf.name"
            style="width: 350px"
            maxlength="32"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="人群描述:" :label-width="formLabelWidth" required>
          <el-input
            v-model="formRf.description"
            style="width: 350px"
            maxlength="32"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          @click="goMarketing()"
          style="width: 150px"
          v-preventReClick
        >
          生成人群并去营销
        </el-button>
        <el-button type="primary" @click="generateCrowd()" v-preventReClick>
          确定生成
        </el-button>
        <el-button @click="dialogFormVisRf = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="流失参数设置" :visible.sync="dialogVisChange" width="30%">
      <span
        >流失定义：距离最近一次购买
        <el-select v-model="opValue" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        天
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisChange = false">取 消</el-button>
        <el-button type="primary" @click="changeValue">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  RF_Standard_Ana,
  saveCrowd,
  lostCustomer,
} from "@/api/analysis/rfmStandard";
import echarts from "echarts";
export default {
  data() {
    return {
      pageName:"数据分析-营销洞察",
      options: [
        {
          value: 180,
          label: "180",
        },
        {
          value: 270,
          label: "270",
        },
        {
          value: 360,
          label: "360",
        },
      ],
      daysTime: 180,
      opValue: 180,
      dialogVisChange: false,
      loading: false,
      timeType: 7,
      myCharts: null,
      formData: {
        timeType: 7,
        daysTime: 180,
      },
      dataList: {},
      dialogFormVisRf: false,
      formLabelWidth: "120px",
      formRf: {
        name: "",
        description: "",
      },
      activeName: "first",
      radio: 3,
      tabelData: [],
      tabelDataListsss: [
        { name: "R≤30天", label: "(近30天有交易)" },
        { name: "30<R≤90天", label: "(近30-90天内有交易)" },
        { name: "90<R≤180", label: "(近90-180天有交易)" },
        { name: "180<R≤360", label: "(近180-360天内有交易)" },
        { name: "R>360", label: "(360天前有交易)" },
      ],
      list: [],
      listtwo: [],
      currentdate: "",
      customerOne: "",
    };
  },
  mounted() {
    this.dateFormat();
    this.rfRequest();
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab.name);
      if (tab.name == "second") {
        this.changeTime();
      }
    },
    //获得当前时间
    dateFormat() {
      var date = new Date();
      console.log(date);
      var seperator1 = "-";
      var seperator2 = " ";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate =
        year +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      this.currentdate = currentdate;
    },
    //rf分析
    rfRequest() {
      RF_Standard_Ana()
        .then((res) => {
          if (res && res.code == 1) {
            this.tabelData = res.data;
            let sum1 = 0;
            let sum2 = 0;
            let sum3 = 0;
            let sum4 = 0;
            let sum5 = 0;
            let sum6 = 0;
            let sum7 = 0;
            let sum8 = 0;
            let sum9 = 0;
            let sum10 = 0;
            let sum11 = 100;
            let a10 = res.data[1][0].customerPercent;
            let a11 = res.data[1][1].customerPercent;
            let a12 = res.data[1][2].customerPercent;
            let a13 = res.data[1][3].customerPercent;
            let a14 = res.data[1][4].customerPercent;
            let a20 = res.data[2][0].customerPercent;
            let a21 = res.data[2][1].customerPercent;
            let a22 = res.data[2][2].customerPercent;
            let a23 = res.data[2][3].customerPercent;
            let a24 = res.data[2][4].customerPercent;
            let a30 = res.data[3][0].customerPercent;
            let a31 = res.data[3][1].customerPercent;
            let a32 = res.data[3][2].customerPercent;
            let a33 = res.data[3][3].customerPercent;
            let a34 = res.data[3][4].customerPercent;
            let a40 = res.data[4][0].customerPercent;
            let a41 = res.data[4][1].customerPercent;
            let a42 = res.data[4][2].customerPercent;
            let a43 = res.data[4][3].customerPercent;
            let a44 = res.data[4][4].customerPercent;
            let a50 = res.data[5][0].customerPercent;
            let a51 = res.data[5][1].customerPercent;
            let a52 = res.data[5][2].customerPercent;
            let a53 = res.data[5][3].customerPercent;
            let a54 = res.data[5][4].customerPercent;
            sum1 =
              (a10 * 100 + a11 * 100 + a12 * 100 + a13 * 100 + a14 * 100) / 100;
            sum2 =
              (a20 * 100 + a21 * 100 + a22 * 100 + a23 * 100 + a24 * 100) / 100;
            sum3 =
              (a30 * 100 + a31 * 100 + a32 * 100 + a33 * 100 + a34 * 100) / 100;
            sum4 =
              (a40 * 100 + a41 * 100 + a42 * 100 + a43 * 100 + a44 * 100) / 100;
            sum5 =
              (a50 * 100 + a51 * 100 + a52 * 100 + a53 * 100 + a54 * 100) / 100;
            // sum11 = sum1 + sum2 + sum3 + sum4 + sum5;
            this.list = [sum1, sum2, sum3, sum4, sum5, sum11];
            sum6 =
              (a10 * 100 + a20 * 100 + a30 * 100 + a40 * 100 + a50 * 100) / 100;
            sum7 =
              (a11 * 100 + a21 * 100 + a31 * 100 + a41 * 100 + a51 * 100) / 100;
            sum8 =
              (a12 * 100 + a22 * 100 + a32 * 100 + a42 * 100 + a52 * 100) / 100;
            sum9 =
              (a13 * 100 + a23 * 100 + a33 * 100 + a43 * 100 + a53 * 100) / 100;
            sum10 =
              (a14 * 100 + a24 * 100 + a34 * 100 + a44 * 100 + a54 * 100) / 100;
            this.listtwo = [sum6, sum7, sum8, sum9, sum10];
          } else {
            this.$message.error(res.data.message);
          }
          // console.log(this.list,this.listtwo,333333);
        })
        .catch((res) => {});
    },
    //生成人群
    SendTextMessage(item, _item, index, _index) {
      // console.log(_item, _index, 22222222222);
      this.dialogFormVisRf = true;
      this.formRf.name = "RFM创建 " + this.currentdate;
      this.formRf.description = "RFM创建 " + this.currentdate;
      this.formRf.strategy = _item.strategy;
    },
    //生成人群并去营销
    goMarketing() {
      if (!this.formRf.name) {
        this.$message.warning("人群名称不能为空");
        return;
      }
      if (!this.formRf.description) {
        this.$message.warning("人群描述不能为空");
        return;
      }
      saveCrowd(this.formRf)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success(res.message);
            // console.log(res.data,22222);
            this.dialogFormVisRf = false;
            window.localStorage.setItem("strategy", JSON.stringify(res.data));
            let routeUrl = this.$router.resolve({
              path: "../../marketing/marketing/accurate_market",
              query: {
                preId: res.data.precisionCrowdStrategyId,
              },
            });
            window.open(routeUrl.href, "_blank");
          }
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    //确定生成
    generateCrowd() {
      if (!this.formRf.name) {
        this.$message.warning("人群名称不能为空");
        return;
      }
      if (!this.formRf.description) {
        this.$message.warning("人群描述不能为空");
        return;
      }
      saveCrowd(this.formRf)
        .then((res) => {
          console.log(res, 22222222);
          if (res && res.code == 1) {
            this.$message.success(res.message);
            this.dialogFormVisRf = false;
          }
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    changeValue() {
      this.dialogVisChange = false;
      this.daysTime = this.opValue;
      this.changeTime();
    },
    //折线图
    initChart() {
      this.myCharts = echarts.init(this.$refs.payRemindChart);
      this.setOptions(this.dataList);
    },
    //折线图事件
    setOptions({ totalCount, oneCount, twoCount, threeCount, dateTime } = {}) {
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [
            "总流失客户",
            "一次购买流失客户",
            "二次购买流失客户",
            "三次及以上购买流失客户",
          ],
          bottom: -5,
          left: "30%",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: dateTime,
        },
        yAxis: {
          type: "value",
           axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            name: "总流失客户",
            type: "line",
            smooth: true,
            areaStyle: {},
            color: "#7F85E9",
            data: totalCount,
          },
          {
            name: "一次购买流失客户",
            type: "line",
            smooth: true,
            areaStyle: {},
            color: "#5882FB",
            data: oneCount,
          },
          {
            name: "二次购买流失客户",
            type: "line",
            color: "#FF872F",
            areaStyle: {},
            smooth: true,
            data: twoCount,
          },
          {
            name: "三次及以上购买流失客户",
            type: "line",
            color: "#FE4D45",
            areaStyle: {},
            smooth: true,
            data: threeCount,
          },
        ],
      };
      this.myCharts.setOption(option);
    },
    //折线图数据查询
    changeTime() {
      this.loading = true;
      lostCustomer({ timeType: this.timeType, daysTime: this.daysTime })
        .then((res) => {
          if (res && res.code == 1) {
            this.loading = false;
            let dataLi = res.data;
            let totalCount = [];
            let oneCount = [];
            let twoCount = [];
            let threeCount = [];
            let dateTime = [];
            dataLi.forEach((item) => {
              totalCount.push(item.totalCount);
              oneCount.push(item.oneCount);
              twoCount.push(item.twoCount);
              threeCount.push(item.threeCount);
              dateTime.push(item.dateTime.substring(0, 10));
            });
            this.dataList = {
              totalCount: totalCount,
              oneCount: oneCount,
              twoCount: twoCount,
              threeCount: threeCount,
              dateTime: dateTime,
            };
            this.$nextTick(() => {
              this.initChart();
              window.addEventListener("resize", () => {
                this.myCharts.resize();
              });
            });
          } else {
            this.loading = false;
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {});
    },
  },
};
</script>

<style scoped lang="scss">
.bgfour {
  background-color: #fb9d9d;
}
.bgthree {
  background-color: #fcb5b5;
}
.bgtwo {
  background-color: #fdcece;
}
.bgone {
  background-color: #fee6e6;
}
.gray {
  background-color: #f9f9f9;
}
.twogary {
  &:nth-child(2n) {
    background-color: #f9f9f9 !important;
  }
}
.section-right-content-box {
  background-color: #fff;
  /*box-shadow: 0px 8px 20px rgba(139, 156, 188, 0.16);*/
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  // padding: 33px 30px 16px 30px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid rgba(230, 230, 230, 1);
  opacity: 1;
  margin: 11px 20px;
  .top-panel {
    padding: 0 0 15px 0;
    overflow: hidden;
  }
  .contentAll {
    padding: 20px 30px 120px 30px;
    .top-panel_span {
      font-size: 14px;
      // font-family: PingFang SC;
      margin-right: 30px;
      font-weight: 400;
      line-height: 20px;
      color: #333333;
      opacity: 1;
    }
    .rfm {
      margin-top: 20px;
      width: 1000px;
      display: flex;
      .buy {
        display: flex;
      }
      .nums {
        display: flex;
      }
    }
    .border {
      @media screen and (min-width: 1700px) and (max-width: 2000px) {
        // line-height: 68px;
        min-width: 235px;
      }
      @media screen and (min-width: 1600px) and (max-width: 1700px) {
        // line-height: 68px;
        min-width: 190px;
      }
      @media screen and (min-width: 1500px) and (max-width: 1599px) {
        // line-height: 69px;
        min-width: 175px;
      }
      @media screen and (min-width: 1400px) and (max-width: 1499px) {
        // line-height: 69px;
        min-width: 160px;
      }
      @media screen and (min-width: 1357px) and (max-width: 1399px) {
        // line-height: 69px;
        min-width: 152px;
      }
      @media screen and (min-width: 1320px) and (max-width: 1356px) {
        // line-height: 69px;
        min-width: 146px;
      }
      @media screen and (max-width: 1319px) {
        // line-height: 69px;
        min-width: 140px;
      }
      // @media screen and (max-width: 1399px) {
      //   // line-height: 70px;
      //   min-width: 237px;
      // }
      height: 90px;
      border: 1px solid #fff;
      text-align: center;
    }
    .count {
      display: flex;
      justify-content: center;
      align-items: center;

      flex-direction: column;
      span {
        color: #333333;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        display: block;
      }
      div {
        color: #333333;
      }
    }
    .qqq {
      line-height: 90px;
    }
    .sss {
      display: flex;
      justify-content: center;
      flex-direction: column;
      &:nth-child(2n + 1) {
        background-color: #f9f9f9;
      }
    }
    .overstriking {
      font-weight: 700;
    }
    .red {
      font-weight: 700;
      color: #ff0000;
    }
    .display {
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.7);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .wrap {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .note {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        display: flex;

        button {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          background-color: #fe4d45;
          border: 0px;
          width: 80px;
          height: 30px;
          line-height: 30px;
          font-size: 15px;
          border-radius: 5px;
          color: #ffffff;
          padding: 0;
          &:focus {
            outline: 0;
          }
        }
      }
      .btn {
        display: none;
      }
      &:hover {
        .btn {
          display: block;
        }
      }
    }
  }
}
</style>